import { render, staticRenderFns } from "./BorderedBox.vue?vue&type=template&id=4f544814&scoped=true"
import script from "./BorderedBox.vue?vue&type=script&lang=js"
export * from "./BorderedBox.vue?vue&type=script&lang=js"
import style0 from "./BorderedBox.vue?vue&type=style&index=0&id=4f544814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f544814",
  null
  
)

export default component.exports